<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<div class="d-flex">
					<h1 class="h3 mb-0 text-gray-800">
						Categorias de Produtos
					</h1>
				</div>
				<div>
			        <button 
						class="btn btn-primary ml-2"
						@click="create()">
						Novo
					</button>
					<button 
				    	@click="$router.go(-1)" 
				    	class="btn btn-secondary">
			        	Voltar
			        </button>
				</div>
			</div>
			<div class="card">
                <div class="card-header">
		        	<div class="d-flex justify-content-between container-fluid">
			            <div class="text-muted fs-19">
			            	<strong>Registros</strong>
			            </div>
				    </div>
		        </div>
		        <div class="card-body">
		            <categoria-produto-table
		            	:key="categKey"
		            	@update="update"
		            	@destroy="destroy">
		            </categoria-produto-table>
		        </div>
		    </div>
		</div>
		<!-- Create -->
		<categoria-produto-create
			@reload="reload">
		</categoria-produto-create>
		<!-- Update -->
		<categoria-produto-update
			:dado_id="dado_id"
			@reload="reload">
		</categoria-produto-update>
		<!-- Delete -->
		<bsh-confirm 
        	modal_id="confirm_destroy_categ_produto" 
        	:dado_id="dado_id" 
        	title="Deseja realmente excluir esta categoria?" 
        	btn="Excluir" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/categ-produtos/destroy/'" 
        	@reload="reload">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				categKey: 0,
				dado_id: 0
			}
		},
		methods: {
			create(){
				$('#create_categ_produto').modal('show');
			},
			update(id){
				this.dado_id = id;
				$('#update_categ_produto').modal('show');
			},
			destroy(id){
				this.dado_id = id;
				$('#confirm_destroy_categ_produto').modal('show');
			},
			reload(){
				this.categKey += 1;
			}
		}
	}
</script>